"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELECT_DELIVERY_FREQUENCY = void 0;
const SELECT_DELIVERY_FREQUENCY = exports.SELECT_DELIVERY_FREQUENCY = 'select-delivery-frequency';
//# sourceMappingURL=constants.js.map